import React from 'react';
import { Bulbs } from './layout/V5Chrome';
type PageHeroProps = {
  title: string;
  subtitle?: string;
  image?: string;
  ghost?: string;
  children?: React.ReactNode;
};

/* v5 page header: blurred photo glow, bulb row, gold script eyebrow, neon condensed title. */
export function PageHero({
  title,
  subtitle,
  image,
  ghost,
  children
}: PageHeroProps) {
  return <section className="tis-hero" data-id="element-237" data-mp="25bz4nxb7fkl">
      {image && <div className="bg" style={{
      backgroundImage: `url("${image}")`
    }} aria-hidden="true" data-id="element-238" data-mp="pu4q05z2qx8c" />}
      <div className="ghost" aria-hidden="true" data-id="element-239" data-mp="ur4uwdk6ttxv">
        {ghost ?? title}
      </div>
      <Bulbs n={7} data-id="element-240" data-mp="g3tik9g6m5wp" />
      {subtitle && <span className="tis-eyebrow" data-id="element-241" data-mp="g2qu086c0fjy">{subtitle}</span>}
      <h1 className="tis-title tis-neon" data-id="element-242" data-mp="l23eim9qdajd">{title}</h1>
      {children}
    </section>;
}